import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="bg-secondary-100/60 rounded-2xl py-14 md:py-16 px-6 md:px-12 mb-6">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-1/4">
              <Link to="/" className="flex items-center gap-2.5 mb-4">
                <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                  <span className="text-background-50 font-bold text-xs font-label">AC</span>
                </div>
                <span className="text-foreground-950 font-semibold text-base font-label">
                  ACBuy
                </span>
              </Link>
              <p className="text-foreground-600 text-sm leading-relaxed font-label">
                The ultimate ACBuySpreadsheet system for smarter, cheaper, and safer shopping from China. Trusted by thousands of global buyers.
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h4 className="text-foreground-800 text-xs font-semibold uppercase tracking-wider mb-4 font-label">Categories</h4>
                <div className="flex flex-col gap-2">
                  {categories.slice(0, 7).map((cat) => (
                    <a
                      key={cat.slug}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap font-label"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-foreground-800 text-xs font-semibold uppercase tracking-wider mb-4 font-label">More Categories</h4>
                <div className="flex flex-col gap-2">
                  {categories.slice(7).map((cat) => (
                    <a
                      key={cat.slug}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap font-label"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-foreground-800 text-xs font-semibold uppercase tracking-wider mb-4 font-label">Resources</h4>
                <div className="flex flex-col gap-2">
                  <Link
                    to="/article/acbuyspreadsheet-complete-guide"
                    className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap font-label"
                  >
                    Complete Guide
                  </Link>
                  <a
                    href="https://kaspreadsheet.com/"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap font-label"
                  >
                    acbuy spreadsheet
                  </a>
                  <a
                    href="https://kaspreadsheet.com/"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap font-label"
                  >
                    Buy It Now
                  </a>
                  <Link
                    to="/"
                    className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors whitespace-nowrap font-label"
                  >
                    Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between py-5 border-t border-secondary-200/50 gap-3">
          <div className="flex items-center gap-4 text-foreground-500 text-xs font-label">
            <span>&copy; 2026 ACBuySpreadsheet. All rights reserved.</span>
            <span className="hidden sm:inline">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors whitespace-nowrap">Privacy Policy</a>
            <span className="hidden sm:inline">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors whitespace-nowrap">Terms of Service</a>
          </div>
          <div className="flex items-center gap-3">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950 text-secondary-50 text-sm hover:bg-foreground-700 transition-colors cursor-pointer" aria-label="Instagram">
              <i className="ri-instagram-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950 text-secondary-50 text-sm hover:bg-foreground-700 transition-colors cursor-pointer" aria-label="X / Twitter">
              <i className="ri-twitter-x-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}